import {Component, EventEmitter, Input, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {SummaryFieldModule} from "../summary-field/summary-field.module";
import {SelectableItem} from "../../selectableItem";
import {ScssService} from "../../utils/scss.service";
import {TablerIconsModule} from "angular-tabler-icons";

@Component({
  selector: 'app-chip',
  standalone: true,
  imports: [CommonModule, SummaryFieldModule, TablerIconsModule],
  templateUrl: './chip.component.html',
  styleUrls: [
      'chip.component.scss'
  ]
})
export class ChipComponent<V> {
  @Input() chip: ChipItem<V>;
  @Input() canUnSelect = true;
  @Input() disabled = false;
  @Output() selectedChangedEvent: EventEmitter<ChipItem<V>> = new EventEmitter();
  @Output() focussedEvent: EventEmitter<void> = new EventEmitter();

  constructor(public scssService: ScssService) {

  }

  selectedChanged() {
    this.focussedEvent.emit();
    if (this.disabled) {
      return;
    }
    if (this.chip.selected && !this.canUnSelect) {
      return;
    }

    this.chip.selected = !this.chip.selected;
    this.selectedChangedEvent.emit(this.chip);
  }
}


export class ChipItem<V> extends SelectableItem<V>{
  label: string;

  public static createChipItem<T>(value: T, label: string): ChipItem<T> {
    return {
      label,
      value: value,
      selected: false
    };
  }

  public static createSelectedChipItem<T>(value: T, label: string): ChipItem<T> {
    return {
      label,
      value: value,
      selected: true
    };
  }
}